import { request } from './apiClient';
import { getSessionClientId } from './authSession';

const onlyDigits = (value) => (value || '').replace(/\D/g, '');

// Monta o payload de moldador (camelCase, documentos só com dígitos) com o cliente da sessão.
export const buildMoldadorPayload = (formData) => ({
  nomeMoldador: formData.nome.trim(),
  numrCpf: onlyDigits(formData.cpf),
  numrTelefone: onlyDigits(formData.telefone),
  enderecoEmail: formData.email.trim(),
  idCliente: getSessionClientId(),
  ativo: formData.ativo,
});

// Lista todos os moldadores.
export const getMoldador = async (idCliente) => {
  // AJUSTE BACKEND AQUI: endpoint de listagem de moldadores.
  const effectiveClientId = idCliente || getSessionClientId();
  return await request(`/api/moldador?idCliente=${effectiveClientId}`);
};

// Cria um moldador; retorna { response, payload }.
export const createMoldador = async (formData) => {
  const payload = buildMoldadorPayload(formData);

  // AJUSTE BACKEND AQUI: endpoint de criacao de moldador.
  const response = await request('/api/moldador', {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Atualiza o moldador por id; retorna { response, payload }.
export const updateMoldador = async (id, formData) => {
  const payload = buildMoldadorPayload(formData);
  payload.idMoldador = Number(id);

  // AJUSTE BACKEND AQUI: update por id do moldador.
  const response = await request(`/api/moldador/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Exclui o moldador por id.
export const deleteMoldador = async (id) => {
  // AJUSTE BACKEND AQUI: exclusao por id do moldador.
  return await request(`/api/moldador/${id}`, {
    method: 'DELETE'
  });
};